module.exports = __webpack_public_path__ + "static/media/5_file_import_requirements_and_best_practices.e3ea6c81.png";